// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"20707fe0","364":"18c2169a","367":"b532bfb9","450":"816a5de5","906":"dcfe4a0b"}[chunkId] + ".chunk.js";
};